export default __webpack_public_path__ + "static/media/fiolet_router.07737333.svg";